import md5 from 'js-md5';
import axios from 'axios';

export function makeKey(key:String) {
  var myDate:any = new Date();
  var random = Math.floor(Math.random() * (100000 - 1)) + 1;
  var k = myDate * random;
  return key + md5(String(k));
}
export async function getAvinfo(url:string) {
  axios.defaults.withCredentials = false;
  let data;
  await axios.get(url + '?avinfo').then(res => {
    data = (res as any).data.format;
  }).catch(err => {
    let msg = err;
  });

  return data;
}
